import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PhotoUploader } from "@/components/PhotoUploader";

export const VERIFICATION_LABEL = { belum: "Belum diajukan", menunggu: "Menunggu", terverifikasi: "Terverifikasi", ditolak: "Ditolak" };
const CLS = { belum: "bg-stone-100 text-stone-600", menunggu: "bg-amber-50 text-amber-800", terverifikasi: "bg-emerald-50 text-emerald-800", ditolak: "bg-rose-50 text-rose-700" };

export const VerificationSection = ({ profile, onChange }) => {
  const v = profile.verification || { status: profile.verified ? "terverifikasi" : "belum" };
  const status = profile.verified ? "terverifikasi" : v.status;
  const [ktp, setKtp] = useState([]);
  const [doc, setDoc] = useState([]);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/provider/verification", { ktp_path: ktp[0], doc_path: doc[0] || null });
      toast.success("Dokumen terkirim. Tim kami akan meninjau dalam 1–2 hari kerja.");
      onChange(data);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-soft mt-8 space-y-4 p-6 sm:p-8" data-testid="verification-section">
      <div className="flex flex-wrap items-center gap-3">
        <ShieldCheck className="h-5 w-5 text-teal-700" />
        <h2 className="text-lg font-bold text-stone-900">Verifikasi Akun</h2>
        <span className={`rounded-full px-3 py-1 text-xs font-semibold ${CLS[status]}`} data-testid="verification-status">{VERIFICATION_LABEL[status]}</span>
      </div>
      {status === "ditolak" && <p className="rounded-xl bg-rose-50 p-3 text-sm text-rose-800" data-testid="verification-reason">Alasan penolakan: {v.reason}</p>}
      {status === "menunggu" && <p className="text-sm text-stone-600">Dokumen Anda sedang ditinjau admin.</p>}
      {status === "terverifikasi" && <p className="text-sm text-stone-600">Profil Anda menampilkan lencana Terverifikasi.</p>}
      {(status === "belum" || status === "ditolak") && (
        <>
          <p className="text-sm text-stone-500">Unggah foto KTP (wajib) dan dokumen usaha (opsional, mis. NIB). Dokumen bersifat privat dan hanya dapat dilihat oleh Anda dan admin Tuntas.</p>
          <div className="grid gap-6 sm:grid-cols-2">
            <div><p className="mb-2 text-xs font-semibold text-stone-600">Foto KTP</p><PhotoUploader value={ktp} onChange={setKtp} max={1} privateUpload testId="ktp-uploader" /></div>
            <div><p className="mb-2 text-xs font-semibold text-stone-600">Dokumen usaha (opsional)</p><PhotoUploader value={doc} onChange={setDoc} max={1} privateUpload testId="business-doc-uploader" /></div>
          </div>
          <Button onClick={submit} disabled={!ktp.length || busy} className="rounded-xl bg-teal-700 hover:bg-teal-800" data-testid="verification-submit-button">Ajukan Verifikasi</Button>
        </>
      )}
    </div>
  );
};
